import React, { Fragment } from 'react';
import { Menu, Layout, Switch, Modal, message, Icon } from 'antd';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getImageUrl, WidgetType, getProfileToken, UserApps, getAppLogo, getValue4Lang } from '~/common';
import { SortableContainer, SortableHandle, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { DefaultImage } from '~/components'
import { getCovidRiskMapUrl } from '~/client'

const { Sider } = Layout;


class AsideMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sortable: false,
        };
    }
    handlePreCollapsed = collapsed => {
        if (collapsed) {
            this.setState({ willCollapse: true });
            setTimeout(() => {
                this.props.handleCollapsed(collapsed);
                this.setState({ willCollapse: false });
            }, 500);
        } else {
            this.props.handleCollapsed(collapsed);
        }
    }

    handlePreMenuItemClick = e => {
        if (!e.key || e.key.indexOf('item_') > -1 || e.key.indexOf('link_') > -1 || e.key === this.props.selectedKeys[0]) return;
        if (e.key === "covid") {
            !this.state.covidLoading && this.showCovidBox();
            return;
        }
        if (this.props.selectedKeys[0] === 'dashboard' || this.props.isMobileMenu) {
            this.handlePreCollapsed(true);
        } else if (e.key === 'dashboard') {
            this.handlePreCollapsed(false);
        }
        this.props.handleMenuItemClick(e);
    }
    renderWidgets = () => {
        let { widgets: items, intl, isMobileMenu } = this.props;
        const DragHandle = SortableHandle(() => <i className="drag-icon"></i>);
        const SortableItem = SortableElement(({ item, sortIndex }) => {
            let title = intl.formatMessage({ id: item.FormatMessageId });
            return (<div className={`widget-menu-item widgets-item sortable'`}><DragHandle />
                <span><font>{title}</font></span>
                <div className="switch-box">
                    <Switch defaultChecked={item.IsVisible} index={sortIndex} onChange={(checked) => this.switchChange(checked, sortIndex)} />
                </div>
            </div>)
        });
        const SortableWidgets = SortableContainer(({ items }) => {
            return (
                <div>
                    {items.map((ele, index) => {
                        return <SortableItem sortIndex={index} key={`item-${index}`} index={index} item={ele} />
                    })}
                </div>
            )
        });
        return (
            <Fragment>
                {this.state.sortable && <SortableWidgets items={items} onSortEnd={this.onSortEnd} useDragHandle={true} transitionDuration={100} />}
                {!this.state.sortable && <Menu
                    theme="dark"
                    className='menu-list'
                    onClick={_ => isMobileMenu && this.props.handleCollapsed(true)}
                >{items.map((ele, index) => (
                    ele.IsVisible && <Menu.Item key={index} className={`widget-menu-item widgets-item un-sortable`}>
                        <a href={`#${ele.EleId}`}>
                            <FormattedMessage id={ele.FormatMessageId} />
                        </a>
                    </Menu.Item>
                ))}
                </Menu>}
            </Fragment>)
    }
    onSortEnd = ({ oldIndex, newIndex }) => {
        this.props.handleWidgets(arrayMove(this.props.widgets, oldIndex, newIndex));
    };

    handleSortable = () => {
        this.setState({ sortable: !this.state.sortable });
    };
    switchChange = (checked, index) => {
        this.props.widgets[index].IsVisible = checked;
        this.props.handleWidgets(JSON.parse(JSON.stringify(this.props.widgets)));
    };
    showCovidBox = () => {
        this.setState({ covidLoading: true });
        getCovidRiskMapUrl({ profileToken: getProfileToken() }, (err, data) => {
            if (data) {
                data.Status === 0 ? this.setState({
                    covidVisible: true,
                    covidUrl: data.Url,
                    covidLoading: false
                }) : message.warning(data.Msg);
            }
            this.setState({ covidLoading: false });
        })
    };
    handleCovidCancel = () => {
        this.setState({
            covidVisible: false
        });
    };


    render() {
        const {
            collapsed,
            selectedKeys,
            className,
            collapsedWidth,
            trigger,
            showDashboard,
            isLightMode,
            menuUserApps,
            handleAppClick,
            companyLogoUrl,
            companyLogoSize,
            availCTMPortalAreas,
        } = this.props;
        let sortable = this.state.sortable;
        const showCTMInvoice = this.props.widgets.some((w) => w.WidgetType === WidgetType.CTMInvoice);
        const showTravelerTracker = this.props.widgets.some((w) => w.WidgetType === WidgetType.TravellerTracker);
        const showFareForecaster = this.props.widgets.some((w) => w.WidgetType === WidgetType.FareForecaster);
        const showPreTrip = this.props.widgets.some((w) => w.WidgetType === WidgetType.CustomBooking);
        const showTripProposal = this.props.widgets.some((w) => w.WidgetType === WidgetType.TripProposal);
        const logoWidth = companyLogoSize && companyLogoSize.split('/')[0] || '';
        const logoHeight = companyLogoSize && companyLogoSize.split('/')[1] || '';
        let fillColor = '#fff';
        if (sortable) {
            fillColor = '#007aff';
        } else if (isLightMode) {
            // fillColor = '#007aff';
            fillColor = '#2D3840'
        }
        return (
            <Sider
                collapsible
                collapsed={collapsed}
                onCollapse={collapsed => this.handlePreCollapsed(collapsed)}
                width={300}
                collapsedWidth={collapsedWidth}
                className={`aside-menu ${className}${this.state.willCollapse ? ' will-collapse' : ''}`}
                trigger={trigger}
            >
                {companyLogoUrl && <div className='agent-logo'>
                    <div className='agent-logo-inner'>
                        <img src={companyLogoUrl} style={!companyLogoSize ? null : { width: logoWidth ? (logoWidth + 'px') : 'auto', height: logoHeight ? (logoHeight + 'px') : 'auto' }} />
                    </div>
                </div>}
                <div className='menu-trigger'>
                    <i className='trigger-icon' onClick={() => this.handlePreCollapsed(!collapsed)}></i>
                </div>
                <Menu
                    theme="dark"
                    selectedKeys={[...selectedKeys, ...(availCTMPortalAreas || []).filter(v => v.IsSelected).map(v => `link_${v.Code}`)]}
                    mode="inline"
                    onClick={this.handlePreMenuItemClick}
                    className='menu-list'
                >
                    {showDashboard &&
                        <Menu.Item key="dashboard">
                            <Link to='/' style={{ marginTop: 8 }}>
                                <i className='dashboard-icon'></i>
                                <FormattedMessage id='dashboard' />
                            </Link>
                        </Menu.Item>
                    }
                    {menuUserApps.length && <Menu.Item className='header-item'>
                        <FormattedMessage id='my_apps' />
                    </Menu.Item>}
                    {
                        menuUserApps.map(app => {
                            let defaultApp = UserApps.find(a => a.AppId === app.AppId);
                            return <Menu.Item key={'item_' + app.AppId} onClick={() => handleAppClick(app)}>
                                <i className='app-icon'>
                                    <DefaultImage src={getAppLogo(app, this.props.themeType)} defaultImg={defaultApp && defaultApp.DefaultAppLogo} alt="" className="initial" />
                                </i>
                                <span>{app.DisplayName}</span>
                            </Menu.Item>
                        })
                    }

                    <Menu.Item className='header-item'>
                        <FormattedMessage id='tools' />
                    </Menu.Item>
                    {showTripProposal && <Menu.Item key="trip-proposal" >
                        <Link to='/trip-proposal'>
                            <i className='trip-proposal-icon'></i>
                            <FormattedMessage id='online_trip_proposal' />
                        </Link>
                    </Menu.Item>}
                    {showTravelerTracker && <Menu.Item key="traveller-tracker">
                        <Link to='/traveller-tracker'>
                            <i className='tracker-icon'></i>
                            <FormattedMessage id='traveler_tracker' />
                        </Link>
                    </Menu.Item>}
                    {showFareForecaster && <Menu.Item key="fare-forecaster">
                        <Link to='/fare-forecaster'>
                            <i className='forecaster-icon'></i>
                            <FormattedMessage id='fare_forecaster' />
                        </Link>
                    </Menu.Item>}
                    <Menu.Item key="covid">
                        <i className='covid-icon'></i>
                        <FormattedMessage id='risk_hub' /> {this.state.covidLoading && <Icon type="loading" />}
                    </Menu.Item>
                    {showCTMInvoice && <Menu.Item key="invoices">
                        <Link to='/invoices'>
                            <i className='invoice-icon'></i>
                            <FormattedMessage id='invoices' />
                        </Link>
                    </Menu.Item>}
                    {showCTMInvoice && <Menu.Item key="vouchers">
                        <Link to='/vouchers'>
                            <i className='invoice-icon'></i>
                            <FormattedMessage id='vouchers' />
                        </Link>
                    </Menu.Item>}
                    <Modal
                        visible={this.state.covidVisible}
                        onCancel={this.handleCovidCancel}
                        footer={null}
                        closable={true}
                        centered={true}
                        destroyOnClose={true}
                        width="98%"
                        className="covid-modal"
                        bodyStyle={{ 'height': '95vh' }}
                    >
                        <iframe
                            id="covidIframe"
                            frameBorder="no"
                            scrolling="no"
                            width="100%"
                            height="100%"
                            title="COVID"
                            src={this.state.covidUrl}
                        >
                        </iframe>
                    </Modal>
                    {showPreTrip && <Menu.Item key="pre-trip" >
                        <Link to='/pre-trip'>
                            <i className='pre-trip-icon'></i>
                            <FormattedMessage id='trip_request' />
                        </Link>
                    </Menu.Item>}
                    {(availCTMPortalAreas || []).length > 0 && [
                        <Menu.Item className='header-item' key={'link_header'}>
                            <FormattedMessage id='links' />
                        </Menu.Item>,
                        availCTMPortalAreas.map(area => {
                            return <Menu.Item key={`link_${area.Code}`}>
                                <a href={area.URL || undefined} target='_blank'>
                                    <i className={area.IsExternalLink ? 'external-link-icon' : 'link-icon'}></i>
                                    <span style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {`${area.Embranchment} `}
                                        <small style={{ fontWeight: 400, fontSize: '100%' }}>({getValue4Lang(area.Name, area.NameZhCn, area.NameZhTw, area.NameJaJp)})</small>
                                    </span>
                                </a>
                            </Menu.Item>;
                        })
                    ]}
                    {!showDashboard && !!this.props.widgets.length && <Menu.Item className='header-item'>
                        <FormattedMessage id='widgets' />
                        <i onClick={this.handleSortable}>
                            <svg t="1562035668493" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3355" width="24" height="24"><path fill={fillColor} d="M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56c10.1-8.6 13.8-22.6 9.3-35.2l-0.9-2.6c-18.1-50.5-44.9-96.9-79.7-137.9l-1.8-2.1c-8.6-10.1-22.5-13.9-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85c-2.4-13.1-12.7-23.3-25.8-25.7l-2.7-0.5c-52.1-9.4-106.9-9.4-159 0l-2.7 0.5c-13.1 2.4-23.4 12.6-25.8 25.7l-15.8 85.4c-35.9 13.6-69.2 32.9-99 57.4l-81.9-29.1c-12.5-4.4-26.5-0.7-35.1 9.5l-1.8 2.1c-34.8 41.1-61.6 87.5-79.7 137.9l-0.9 2.6c-4.5 12.5-0.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5c-10.1 8.6-13.8 22.6-9.3 35.2l0.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c8.6 10.1 22.5 13.9 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4c2.4 13.1 12.7 23.3 25.8 25.7l2.7 0.5c26.1 4.7 52.8 7.1 79.5 7.1 26.7 0 53.5-2.4 79.5-7.1l2.7-0.5c13.1-2.4 23.4-12.6 25.8-25.7l15.7-85c36.2-13.6 69.7-32.9 99.7-57.6l81.3 28.9c12.5 4.4 26.5 0.7 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l0.9-2.6c4.5-12.3 0.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9c-11.3 26.1-25.6 50.7-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97c-28.1 3.2-56.8 3.2-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9z" p-id="3356"></path><path d="M512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176z m79.2 255.2C570 602.3 541.9 614 512 614c-29.9 0-58-11.7-79.2-32.8C411.7 560 400 531.9 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8C612.3 444 624 472.1 624 502c0 29.9-11.7 58-32.8 79.2z" fill={fillColor} p-id="3357"></path></svg>
                        </i>
                    </Menu.Item>}
                </Menu>
                {!showDashboard && !!this.props.widgets.length && this.renderWidgets()}
                <div style={{ display: 'none', visibility: 'hidden', fontSize: 0, height: 0, width: 0 }}>
                    {['dashboard', 'profiles', 'lightning', 'tracker', 'forecaster'].map(item => {
                        return (<Fragment key={item}>
                            <img alt='' src={getImageUrl(`${item}.png`)} />
                            <img alt='' src={getImageUrl(`${item}L.png`)} />
                        </Fragment>);
                    })}
                    {['dashboard', 'profiles', 'lightning'].map(item => {
                        return (<Fragment key={item}>
                            <img alt='' src={getImageUrl(`${item}_active.png`)} />
                            <img alt='' src={getImageUrl(`${item}L_active.png`)} />
                        </Fragment>);
                    })}
                </div>
            </Sider >
        );
    }
}

AsideMenu.propTypes = {
    handleCollapsed: PropTypes.func.isRequired,
    handleMenuItemClick: PropTypes.func.isRequired,
    widgets: PropTypes.array,
    menuUserApps: PropTypes.array,
    handleAppClick: PropTypes.func.isRequired,
    availCTMPortalAreas: PropTypes.array,
}

AsideMenu.defaultProps = {
    collapsed: false,
    selectedKeys: ['dashboard'],
    tripCount: {
        deadlineAlert: 0,
        pendingForApproval: 0,
        upcomingTrips: 0,
    },
    menuUserApps: []
}

export default injectIntl(AsideMenu);
